import React, { useState } from "react";
import "./Home.scss";
import NewButton from "./NewButton";

const Home = () => {
  const [ageVerifier, setAgeVerifier] = useState(true);

  return (
    <main className="home-page">
      <div className={`modal ${ageVerifier ? "is-active" : ""}`}>
        <div className="modal-background"></div>
        <div className="modal-content">
          <div className="modal-card">
            <section className="modal-card-body">
              <p>
                YOU MUST BE 19 YEARS OF AGE TO PURCHASE ALCOHOL. PLEASE NOTE
                THAT WE ONLY DELIVER IN ONTARIO{" "}
              </p>
            </section>
            <div className="modal-card-foot">
              <button
                className="button is-dark"
                onClick={() => setAgeVerifier(!ageVerifier)}
              >
                I am over 19
              </button>
            </div>
          </div>
        </div>
      </div>

      <section className="home-top">
        <div className="image-container">
          
          <img
            src="/images/WineBottle.png"
            alt="bottles-img"
            className="image-top"
          />
          <article>
            <h1>Design with a purpose</h1>
            <p>
              IT'S MY WINE allows you to create a personalized label for our
              great tasting wines.
            </p>
            <NewButton text="create your wine" color="yellow" url="/designwine" />
          </article>
          
        </div>
        
      </section>
      <section className="home-bottom">
        <div className="content">
          <p>
            Château des Charmes was founded in 1978 by Paul Bosc, a
            fifth-generation French winegrower. Paul and his young family
            arrived in Niagara in the 1960's with the idea that growing our own
            grapes was the best way to make fine wine. More than ever, we
            believe in this Estate Winery model and we make our wine only from
            grapes we've grown ourselves.
          </p>
          <NewButton text="chateau des charmes" color="gray" url="/winery" />
        </div>
      </section>
      {/* <div
        className="video-container"
        background="@routes.Assets.versioned('images/wine-with-background.jpg')"
      >
        <video src="/videos/Château des Charmes.mp4" autoPlay loop muted />
      </div> */}

      {/* <iframe
        // width="100%"
        // height="725px"
        src="https://www.youtube.com/embed?v=HLImErrlw6g"
        frameborder="100"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      /> */}

      {/* <iframe
        src="https://www.youtube.com/embed/HLImErrlw6g?mute=1&loop=1&modestbranding=1&autoplay=1&fs=0&controls=0&rel=0&info=0"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe> */}
    </main>
  );
};

export default Home;
